import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../environments/environment';

@Injectable()
export class CustomFilterService {
  private rootUrl = environment.API_URL || '';

  constructor(private httpClient: HttpClient) {}

  private getCacheKey(key: string): string {
    return key + '_attributes';
  }

  /**
   * Get attributes from cache or API, returns a Promise
   */
  getAttributesFromCache(key: string, api: boolean = false): Promise<any> {
    const cacheKey = this.getCacheKey(key);

    if (api) {
      return this.getAttributesAsPromise(key);
    } else {
      const data = localStorage.getItem(cacheKey);
      if (data) {
        return Promise.resolve(JSON.parse(data));
      } else {
        return this.getAttributesAsPromise(key);
      }
    }
  }

  /**
   * Fetch attributes via HTTP POST
   */
  fetchAttributes(key: string): Observable<any> {
    const data = {
      id: localStorage.getItem('userID'),
    };
    return this.httpClient.post(this.rootUrl + '/custom/' + key, data);
  }

  /**
   * Process and cache attributes response
   */
  getAttributes(key: string): Observable<any> {
    return this.fetchAttributes(key)
      .do((response: any) => {
        if (response && response.data) {
          this.setToCache(key, response.data);
        }
      })
      .map((response: any) => (response && response.data ? response.data : null));
  }

  /**
   * Convert getAttributes observable to Promise
   */
  getAttributesAsPromise(key: string): Promise<any> {
    return this.getAttributes(key)
      .toPromise()
      .then(response => response)
      .catch(error => {
        console.error(error);
        return null;
      });
  }

  /**
   * Cache attributes in localStorage
   */
  setToCache(key: string, data: any) {
    const cacheKey = this.getCacheKey(key);
    localStorage.setItem(cacheKey, JSON.stringify(data));
  }

  /**
   * Clear attributes cache from localStorage
   */
  clearCache(key: string) {
    const cacheKey = this.getCacheKey(key);
    localStorage.removeItem(cacheKey);
  }

  /**
   * Check and update attributes
   */
  checkAndUpdateAttributes(key: string): Promise<any> {
    const cacheKey = this.getCacheKey(key);

    const data = localStorage.getItem(cacheKey);
    if (data) {
      return this.getAttributesAsPromise(key);
    } else {
      return Promise.resolve([]);
    }
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/custom-filter.service.ts